var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.hasPremiumSubscription
        ? _c("dashboard-notes-activity-card", { staticClass: "mb-6" })
        : _vm._e(),
      _vm._v(" "),
      _c("profile-block"),
      _vm._v(" "),
      _c("updates-block", { staticClass: "mt-6" }),
      _vm._v(" "),
      _c("concurrent-block", { staticClass: "mt-6" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }